import { Outlet } from "@tanstack/react-router";
import SettingsNavigation from "@/components/general/Settings/SettingsNavigation";

export default function SettingsPage() {
    return (
        <main className="flex flex-col p-4 sm:p-6">
            <SettingsNavigation />
            <Outlet />
            <div className="md:hidden py-8" />
        </main>
    );
}
